/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCheckboxProps, TdCheckboxGroupProps } from './type';

export const checkboxDefaultProps: TdCheckboxProps = {
  block: true,
  borderless: undefined,
  checkAll: false,
  defaultChecked: false,
  disabled: undefined,
  icon: 'circle',
  indeterminate: false,
  maxContentRow: 5,
  maxLabelRow: 3,
  placement: 'left',
  readonly: undefined,
};

export const checkboxGroupDefaultProps: TdCheckboxGroupProps = {
  borderless: false,
  disabled: undefined,
  max: undefined,
  readonly: undefined,
  defaultValue: [],
};
